var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Gaarkeuken 110")]),_c('p',[_vm._v(" We zijn net voorbij de gebouwen van Katoennatie, de grootste ‘natie’ in de Antwerpse haven en over de hele wereld vertegenwoordigd. De groep, onder leiding van Fernand Huts, telt meer dan 200 vestigingen in 40 landen. ")]),_c('p',[_vm._v(" Katoen Natie doet de opslag en verwerking van ongelooflijk veel producten. Een van die producten is bier. Met de biertrein van Katoen Natie worden jaarlijks 20.000 vrachtwagens van de Antwerpse Ring gehouden. Katoen Natie transporteert de bieren met de biertrein naar Linkeroever, van waar de bieren per schip vertrekken naar De Verenigde Staten, Canada en Mexico. ")]),_c('img',{attrs:{"src":require("../../public/images/kort-26.jpg")}}),_c('p',[_vm._v(" En biertjes, die worden door dokwerkers ook hier gedronken, in Gaarkeuken 110. ")]),_c('p',[_vm._v("Daarnaast serveren ze typisch Belgische gerechten.")]),_c('v-game',[_c('p',[_vm._v(" Weet jij of de volgende gerechten Belgische of buitenlands zijn? ")]),_c('p',[_c('strong',[_vm._v("Ballekes in Tomaat")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch',
          correct: true
        },
        {
          label: 'Buitenlands'
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Sushi")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch'
        },
        {
          label: 'Buitenlands',
          extra: 'Japan',
          correct: true
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Pizza")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch'
        },
        {
          label: 'Buitenlands',
          extra: 'Italië',
          correct: true
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Videe met frietjes")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch',
          correct: true
        },
        {
          label: 'Buitenlands'
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Hot Dog")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch'
        },
        {
          label: 'Buitenlands',
          extra: 'Duitsland',
          correct: true
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Stoofvlees met frietjes")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch',
          correct: true
        },
        {
          label: 'Buitenlands'
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Groene curry met scampi")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch'
        },
        {
          label: 'Buitenlands',
          extra: 'Thailand',
          correct: true
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Schnitzel")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch'
        },
        {
          label: 'Buitenlands',
          extra: 'Oostenrijk',
          correct: true
        }
      ]}}),_c('p',[_c('strong',[_vm._v("Ovenschotel bloemkool en gehakt")])]),_c('v-multiple-choice',{attrs:{"horizontal":true,"answers":[
        {
          label: 'Belgisch',
          correct: true
        },
        {
          label: 'Buitenlands'
        }
      ]}})],1),(_vm.next)?_c('v-next-step',[_c('p',[_vm._v(_vm._s(_vm.next))]),_c('v-button',{attrs:{"type":"light","icon-right":"arrow-right"},on:{"click":function($event){_vm.state.popoverStepIndex = null}}},[_vm._v(" Ga verder ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }